export default {
    data() {
        return {
            abrirModalDeletarDados: false,
        }
    },
    methods: {
        deletarSelecionados() {
            this.abrirModalDeletarDados = true;
        },

        cancelarDelecao() {
            this.abrirModalDeletarDados = false;
        },
    }
}